export const getQuery = () => new URLSearchParams(window.location.search)